import React from 'react';
import moment from 'moment-timezone';

import NoContent from '../no_content';

import MagooshAI from '../assets/magoosh_ai.svg';

interface Props {
  gradedAt: number;
  grader: {
    name: string;
    type: 'ai' | 'human';
  };
  narrative: string | React.ReactNode;
  sections: {
    bullets: string[];
    title: string;
  }[];
  status: 'waiting' | 'processing' | 'finished' | 'error';
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  if (props.status === 'finished') {
    return (
      <>
        <div className="align-items-center d-flex gap-s">
          {
            props.grader.type !== 'human' && (
              <img alt="" src={MagooshAI} />
            )
          }

          <div className="small">
            {props.grader.name}
            {' '} on {moment.unix(props.gradedAt).tz(timeZone).format('MMMM D, YYYY')}
          </div>
        </div>

        <div className="d-flex flex-column flex-1" style={{ gap: 20 }}>
          <div>{props.narrative}</div>

          {
            props.sections.map((section, idx) => (
              <div key={idx} className="d-flex flex-column" style={{ gap: 10 }}>
                <div>
                  <strong>{section.title}</strong>
                </div>

                <div>
                  <ul>
                    {
                      section.bullets.map((bullet, bulletIdx) => (
                        <li key={bulletIdx}>{bullet}</li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            ))
          }
        </div>
      </>
    );
  } else {
    return (
      <NoContent />
    );
  }
};
